const CUSTOM_PRODUCTION_HOSTS = new Set(["hana.ma", "www.hana.ma"]);

export function getRuntimeBackendUrl() {
  if (typeof window !== "undefined" && CUSTOM_PRODUCTION_HOSTS.has(window.location.hostname)) {
    return window.location.origin;
  }
  return process.env.REACT_APP_BACKEND_URL;
}

export function getRuntimeApiBase() {
  return `${getRuntimeBackendUrl().replace(/\/$/, "")}/api`;
}

export function getRuntimeWsBase() {
  const backendUrl = getRuntimeBackendUrl().replace(/\/$/, "");
  return backendUrl.replace(/^https?/, backendUrl.startsWith("https") ? "wss" : "ws");
}